import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const PlusIcon = (props: IconProps) => (
  <Icon width="24px" height="24px" viewBox="0 0 24 24" {...props}>
    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2Z" />
  </Icon>
);

export default memo(PlusIcon);
